/* eslint-disable react/self-closing-comp */
/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable no-case-declarations */
import React, { useState, useRef, useEffect, Suspense } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import i18n, { changeLanguage, getLanguages } from '../../i18n'

import { LoginPageLeftSide, X, ViewPasswordIcon, HidePasswordIcon } from '../../Constants/assets';
import errorMessages from '../../Constants/ErrorMessages';
import {
    checkRestoreGame,
    createNewGame,
    forgotPass,
} from '../../utils/global';

const InnerContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    font-size: 0.875rem;
`;
const RightSideContainer = styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    width: 35%;

    @media only screen and (max-width: 1150px) {
        & {
            flex: 1;
        }
    }
`;
const ContentContainer = styled.div`
    width: 456px;
    height: 75%;
    place-self: center;
`;
const HeaderContainer = styled.div`
    height: max-content;
`;
const Title = styled.div`
    font-size: 2.625rem;
`;
const Paragraph = styled.div`
    color: ${props => props.theme.colors.gray};
`;
const FormContainer = styled.div``;
const FormLineContainer = styled.div`
    height: 6.8rem;
`;
const Label = styled.label`
    margin-left: 4px;
`;
const ErrorContainer = styled.div`
    font-size: 0.75rem;
    color: ${props => props.theme.colors.red};
    padding: 5px 0px 0px 4px;
    display: ${props => (props.isError ? 'block' : 'none')};
`;
const InvalidCreds = styled.div`
    font-size: 0.75rem;
    color: ${props => props.theme.colors.red};
    padding: 5px 0px 0px 4px;
    display: ${props => (props.isError ? 'block' : 'none')};
`;
const EmptyName = styled.div`
    font-size: 0.75rem;
    color: ${props => props.theme.colors.red};
    padding: 5px 0px 0px 4px;
    display: ${props => (props.isError ? 'block' : 'none')};
`;
const EmptyMail = styled.div`
    font-size: 0.75rem;
    color: ${props => props.theme.colors.red};
    padding: 5px 0px 0px 4px;
    display: ${props => (props.isError ? 'block' : 'none')};
`;
const EmptyPassword = styled.div`
    font-size: 0.75rem;
    color: ${props => props.theme.colors.red};
    padding: 55px 0px 0px 4px;
    display: ${props => (props.isError ? 'block' : 'none')};
`;
const Input = styled.input`
    width: 18.75rem;
    height: 3.125rem;
    border: 1px solid ${props => props.theme.colors.gray};
    border-radius: 4px;
    font-size: 16px;
    padding-left: 19px;
    ::-ms-reveal{
        display: none;
    }
`;
const ResetCon = styled.div`
    width: 12.3125rem;
`;
const ResetPass = styled.div`
    margin-top: 1rem;
    width: 12.3125rem;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 19px;
    color: ${props => props.theme.colors.darkGreen};
    cursor: pointer;
`;
const PopUpContainer = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
`;
const PopUp = styled.div`
    position: absolute;
    width: 30%;
    height: 40%;
    background-color: ${props => props.theme.colors.white};
    left: 35%;
    top: 30%;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
`;
const XContainer = styled.div``
const HeaderText = styled.div`
    padding-top: 1rem;
    margin-left: 10px;
    font-weight: bold;
    font-size: 24px;
    line-height: 4rem;
    margin-left: 2.5rem;
    color: ${props => props.theme.colors.black};
    display: flex;
    width: 65%;
`;
const ParagraphText = styled.div`
    font-weight: 500;
    font-size: 16px;
    text-align: left;
    margin-left: 2.5rem;
    color: ${props => props.theme.colors.black};
`;
const ResetEmail = styled.input`
    position: absolute;
    width: 52%;
    height: 3.125rem;
    border: 1px solid ${props => props.theme.colors.gray};
    border-radius: 4px;
    font-size: 16px;
    top: 50%;
    left: 25%;
    text-indent: 19px;
`;
const ButtonSend = styled.div`
    position: absolute;
    top 86%;
    margin-top: -1.875rem;
    right: 0%;
    margin-right: 40px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: ${props => props.theme.colors.white};
    background: ${props => props.theme.colors.darkGreen};
    border-radius: 4px;
    width: 13.5rem;
    height: 50px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    :active {
        background: ${props => props.theme.colors.lightGray};
    }
`;
const ButtonInput = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: ${props => props.theme.colors.white};
    background: ${props => props.theme.colors.darkGreen};
    border-radius: 4px;
    width: 18.75rem;
    height: 3.125rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    :active {
        background: ${props => props.theme.colors.lightGray};
    }
    ${props =>
        props.clickedLogin
            ? css`
                  background: ${componentProps => componentProps.theme.colors.lightGray};
              `
            : css`
                  background: ${componentProps => componentProps.theme.colors.darkGreen};
                  cursor: pointer;
              `}
`;

const EyeIconContainer = styled.div`
    position: absolute;
    width: 290px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    pointer-events: none;
`;
function MaintanenceMode({ toggleMaintanenceMode }) {
    const [leftSideClicks, setLeftSideClicks] = useState(0);
    const [translationsLoaded, setTranslationsLoaded] = useState(false);
    const { t } = useTranslation();
    const [languages, setLanguages] = useState([]);
    useEffect(() => {
        const fetchLanguages = async () => {
            const translationsData = await getLanguages();

            const languagesList = Object.values(translationsData);

            setLanguages(languagesList);
        };

        fetchLanguages();
    }, []);
    useEffect(() => {
        setTimeout(() => {
            setTranslationsLoaded(true);
        }, 250);
    }, []);

    useEffect(() => {
        if (leftSideClicks >= 6) {
            toggleMaintanenceMode(false);
        }
    }, [leftSideClicks, toggleMaintanenceMode]);

    return (
        <Suspense fallback={<div>Loading...</div>}>
            {translationsLoaded && (
                <InnerContainer>
                    <div>
                        <LoginPageLeftSide onClick={() => { setLeftSideClicks(prev => prev + 1) }} style={{ height: '100vh', width: '100%' }} />
                    </div>
                    <RightSideContainer>
                        <ContentContainer>
                            <HeaderContainer>
                                <Title >{t('maintenance_mode_login.maintenance_mode_login_title')}</Title>
                                <Paragraph dangerouslySetInnerHTML={{ __html: t('maintenance_mode_login.maintenance_mode_login_subtitle').replace(/\n/g, '<br/>') }}>
                                </Paragraph>
                            </HeaderContainer>
                        </ContentContainer>
                    </RightSideContainer>
                </InnerContainer>
            )}
        </Suspense>
    );
}

export default MaintanenceMode;